import _ from 'lodash';
import template from './alertPolicyModal.html';


export default {
  name: 'alertPolicyModalComponent',
  template,
  controller: AlertPolicyModalController,
  controllerAs: 'AlertPolicyModalCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&',
    close: '&'
  }
};

/* @ngInject */
function AlertPolicyModalController(
  EquipmentInfoService,
  EventInfoService,
  growl,
  EquipmentService) {
  const vm = this;
  vm.copy = copy;
  vm.selectedEquipments = [];
  vm.selectedEvents = [];

  vm.updateEventSelection = updateEventSelection;

  const selectableEvents = _.chain(EventInfoService.eventsConfig.definitions)
    .filter(item => _.get(item, 'notificationsEnabled', false))
    .groupBy(item => item.eventName.split('/')[0])
    .value();

  vm.$onInit = () => {
    _.merge(vm, vm.resolve);
    EquipmentInfoService
      .getAllEquipments({ org: vm.org })
      .then((eqList) => { vm.equipments = eqList });
  };

  // filter event list to contain events possible in equipment list
  function updateEventSelection() {
    vm.eqEvents = [];
    _.forEach(_.uniq(_.map(vm.selectedEquipments, 'equipmentType')), (eqType) => {
      vm.eqEvents.push(...selectableEvents[eqType] || []);
    });
  }

  async function copy() {
    if (_.isEmpty(vm.selectedEquipments) || _.isEmpty(vm.selectedEvents)) {
      return void growl.error('Missing equipments or events.', { title: 'Unable to copy: ', ttl: 7000 });
    }
    const growlMessage = growl.info('Saving notifications...', { disableCloseButton: true });

    try {
      const eqToCopy = _.map(vm.selectedEquipments, 'id');
      const eventsToCopy = _.map(vm.selectedEvents, 'eventName');
      const equipment = await EquipmentService.copyEquipmentNoteConfigs(eqToCopy, eventsToCopy, {
        enabled: vm.notificationConfig.enabled,
        escalations: vm.notificationConfig.escalations,
        schedule: vm.notificationConfig.schedule
      });

      growlMessage.destroy();
      growl.success('Notifications Saved');
      vm.close({ $value: equipment });
    } catch (err) {
      growlMessage.destroy();
      growl.error(err.error || err, { title: 'Error Saving Notifications: ' });
    }
  }
}
